import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/cidadao`

    return {
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        show(id) {

            return repository.get(`${baseUrl}/${id}`)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
    }
}